import React from 'react'

export class BaseScreen<P, S> extends React.Component<P, S> {
    // @ts-ignore
    constructor(props) {
        super(props);
    }

}